module.exports = __webpack_public_path__ + "static/img/bg_yunma_bag.f1c2da43.png";